module.exports = __webpack_public_path__ + "img/invite_warning.f15541f0.png";